// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import AsyncRequest from '../classes/AsyncRequest';
import { ajaxParameter } from '../classes/Helpers';

export default class CategoryPage extends Component {
  /**
   * Initialize the category page component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addListener(Notifications.SORT, this.handleFilter);
    this.addListener(Notifications.FILTER, this.handleFilter);

    window.onpopstate = () => {
      window.store.url.refreshSearchParameters();
      this.notify(Notifications.FILTER);
    };
  }

  /**
   * Execute filter
   */
  handleFilter(pData: Object): void {
    this.notify(Notifications.REMOVE_PAGE_INTERACTION);
    AsyncRequest.get(window.location.href + ajaxParameter())
      .then(({ data }: Object) => {
        this.notify(Notifications.FILTERED, { data: data, group: pData.group });
        this.notify(Notifications.LOADED);
        this.notify(Notifications.ADD_PAGE_INTERACTION);
      })
      .catch((error: any) => {
        this.notify(Notifications.ASYNC_FAILED);
        console.warn(error);
      });
  }
}
